function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.324 21.956 20.306 5.99l-2.564-2.578L1.746 19.393.354 22.645c-.068.175-.034.336.103.483.147.156.308.2.483.132l3.384-1.304ZM21.594 4.73l1.48-1.45c.371-.38.567-.761.586-1.142.02-.381-.137-.742-.469-1.084l-.498-.498C22.361.223 22 .07 21.61.1c-.38.029-.757.224-1.128.586L19.002 2.15l2.593 2.578Z",
    fill: props.color || '#212240'
  }));
};

export default SvgEdit;